import { Element } from '../../../common/html/element'
import { PopupAction } from '../../../common/popup/PopupAction'
import { TranslateDelateItems } from '../../common/html/translate/TranslateDelateItems'

export const DeleteItems = ({ isShow, handleClose, handleSubmit, count }) => {
  return (
    <PopupAction
      title="common.CONFIRMATION"
      isShow={isShow}
      handleClose={handleClose}
      btnCancel={{
        label: 'common.NO',
        event: handleClose,
        isI18n: true,
      }}
      btnSubmit={{
        label: 'common.YES',
        event: handleSubmit,
        isI18n: true,
      }}
    >
      <Element>
        <TranslateDelateItems count={count} />
      </Element>
    </PopupAction>
  )
}
